// extracted by mini-css-extract-plugin
export var emailBlockLink = "_nr-0";